module.exports = __webpack_public_path__ + "preview-eac7acfc/open-sans-hebrew-regular-dc71bbd9d1e333b1902ae834dd3db93d.ttf";